import { DataState } from '../../context/DataProvider';
import MeetingApprovalsPanel from '../../components/meeting/MeetingApprovalsPanel';

/**
 * Project-wide view of the approval queues.
 *
 * The same panel is embedded in the meeting detail tab scoped to one meeting;
 * here it runs unscoped, which is the "everything still waiting" view. Sharing
 * the component keeps one implementation of the approve/answer behaviour.
 */
export default function MeetingApprovalsPage() {
  const { userGoogleId: projectToken } = DataState();

  return (
    <div className="min-h-screen w-full bg-[#0a0a0c]">
      <div className="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <h1 className="mb-1 text-xl font-semibold text-zinc-100">
          Meeting approvals
        </h1>
        <p className="mb-6 text-sm text-zinc-500">
          Every meeting in this project.
        </p>
        <MeetingApprovalsPanel accessToken={projectToken} />
      </div>
    </div>
  );
}
